import React, { Fragment, useState } from "react";
import * as actions from "../../../store/actions/index";
import { connect } from "react-redux";
import classes from "./Passkey.css";
import Message from "../../../components/Message/Message";
import ToggleSwitch from "../../../UI/ToggleSwitch/ToggleSwitch";
import Button from "../../../UI/Button/Button";
import Spinner from "../../../UI/Spinner/Spinner";
import Modal from "../../../UI/Modal/Modal";
import { SESSION_READONLYUSER, SESSION_BASELINEAGENT } from '../../../shared/Constants';

const passkey = (props) => {
  const [showDeleteModal, setShowDeleteModal] = useState(null);
  const list = [...props.passkeyList];
  const isOtpVerified =
    props.isOTPVerified || props.isNullHSID || props.isHeadlessUser;
  const userType = props.user.userType;
  const disabledUserTypes = [SESSION_READONLYUSER, SESSION_BASELINEAGENT];

  const onToggle = (item) => {
    const data = {
      uuid: props.healthSafeId,
      credentialId: item.credentialId,
      enableWebAuthentication: !item.enabled,
      name: item.name,
      username: props.member?.essoData?.userName,
    };
    props.togglePasskey(data, list);
  };

  const onDelete = () => {
    const selectedItem = showDeleteModal;
    setShowDeleteModal(null);
    const data = {
      uuid: props.healthSafeId,
      credentialId: selectedItem.credentialId,
      enableWebAuthentication: selectedItem.enabled,
      name: selectedItem.name,
      username: props.member?.essoData?.userName,
    };
    props.deletePasskey(data, list);
  };

  const otpVerificaitonNotifier = isOtpVerified ? null : (
    <div className={classes.OTPMessageDiv}>
      <Message
        msgType="Error"
        info={{ message: "Please verify Identity to edit." }}
      />
    </div>
  );

  const passkeyNotfier = props.passkeyErrorMsg ? (
    <div className={classes.OTPMessageDiv}>
      <Message msgType="Error" info={{ message: props.passkeyErrorMsg }} />
    </div>
  ) : null;

  return (
    <Fragment>
      <Modal show={props.passkeyProcessing}>
        <Spinner />
      </Modal>
      <Modal show={!!showDeleteModal}>
        <div className={classes.deletePasskeyModalWrapper}>
          <div className={classes.deletePasskeyModalText}>
            Are you sure you want to delete this device?
          </div>
          <div className={classes.DeleteModalBtnDiv}>
            <Button
              id="cancelPasskey"
              btnType="PasskeyDeleteModal"
              clicked={() => setShowDeleteModal(null)}
              disabled={false}
            >
              Cancel
            </Button>
            <Button
              id="deletePasskey"
              btnType="PasskeyDeleteModal"
              clicked={onDelete}
              disabled={false}
            >
              Delete
            </Button>
          </div>
        </div>
      </Modal>
      <div className={classes.EilgibilityHeader}>
        <div className={classes.EligibilityHeaderLeftEndDiv}></div>
        <h3 className={classes.EligibilityTitle}>{"Passkey Settings"}</h3>
        {otpVerificaitonNotifier}
      </div>
      <div
        className={`${classes.EligibilityWrapper} ${
          !isOtpVerified ? classes.disableScroll : ""
        }`}
      >
        {isOtpVerified ? null : (
          <div className={classes.EligibilityDisableLayer}></div>
        )}
        {passkeyNotfier}
        <div className={classes.passkeyCardMainWrapper}>
          {list && list.length > 0
            ? list.map((item, index) => {
                return (
                  <div
                    className={`${classes.passkeyCardWrapper} ${
                      index !== list.length - 1
                        ? classes.passkeyCardWrapperBorder
                        : ""
                    }`}
                    key={item.name}
                  >
                    <ToggleSwitch
                      id="togglePasskey"
                      labelText={item.name}
                      status={item.enabled}
                      onText="Enabled"
                      offText="Disabled"
                      disabled={disabledUserTypes.includes(userType)}
                      clicked={() => onToggle(item)}
                    />
                    <Button
                      id="delete"
                      btnType="PasskeyDelete"
                      clicked={() => setShowDeleteModal(item)}
                      disabled={disabledUserTypes.includes(userType)}
                    >
                      Delete this device
                    </Button>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    healthSafeId: state.member?.member?.healthSafeId ?? state.member?.member?.essoData?.uuid,
    processing: state.member.processing,
    user: state.usr.user,
    member: state.member.member,
    essoData: state.member.essoData,
    passkeyList: state.member.passkeyList,
    passkeyProcessing: state.member.passkeyProcessing,
    passkeyErrorMsg: state.member.passkeyErrorMsg,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    togglePasskey: (data, passkeyList) =>
      dispatch(actions.togglePasskey(data, passkeyList)),
    deletePasskey: (data, passkeyList) =>
      dispatch(actions.deletePasskey(data, passkeyList)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(passkey);
